import { PapiDaUserProfileInitStats, PapiUser } from '@wix/da-types-papi';

export enum StatsTimePeriod {
  Week = 'P7D',
  Month = 'P28D',
  Year = 'P365D',
}

export enum MySubmissionsSortBy {
  PublishDate = 'publishDate',
  PageViews = 'pageViews',
  Faves = 'faves',
  Comments = 'comments',
}

export type MySubmissionItem = NonNullable<
  NonNullable<
    NonNullable<PapiDaUserProfileInitStats['sectionData']>['myContent']
  >['timePeriods']['P7D']
>[0];

export type BenchmarkItem = NonNullable<
  NonNullable<
    NonNullable<PapiDaUserProfileInitStats['sectionData']>['compareYourself']
  >['timePeriods']['P7D']
>[0];

export type GeneralStats = NonNullable<
  NonNullable<
    NonNullable<PapiDaUserProfileInitStats['sectionData']>['general']
  >['timePeriods']['P7D']
>;

export type DeviceStats = NonNullable<
  NonNullable<
    NonNullable<PapiDaUserProfileInitStats['sectionData']>['trafficByDevice']
  >['timePeriods']['P7D']
>;

export type CountryStats = NonNullable<
  NonNullable<
    NonNullable<PapiDaUserProfileInitStats['sectionData']>['trafficByCountry']
  >['timePeriods']['P7D']
>;

export enum BenchmarkSortBy {
  ProfileVisitors = 'profileVisitors',
  DeviationViews = 'deviationsViews',
  Faves = 'faved',
  Watchers = 'watchers',
}

type StatsSection = {
  timePeriod: StatsTimePeriod;
  mySubmissionsSortBy: MySubmissionsSortBy;
  mySubmissionsIsLoading: boolean;
  benchmarkSortBy: BenchmarkSortBy;
  benchmarkIsLoading: boolean;
  matchingUsers: PapiUser[];
  stats: Omit<
    NonNullable<PapiDaUserProfileInitStats['sectionData']>,
    'traffic' | 'general'
  > & {
    traffic?: NonNullable<PapiDaUserProfileInitStats['sectionData']>['traffic'];
    general?: NonNullable<PapiDaUserProfileInitStats['sectionData']>['general'];
    trafficByDevice?: NonNullable<
      PapiDaUserProfileInitStats['sectionData']
    >['trafficByDevice'];
    trafficByCountry?: NonNullable<
      PapiDaUserProfileInitStats['sectionData']
    >['trafficByCountry'];
    compareYourself?: NonNullable<
      PapiDaUserProfileInitStats['sectionData']
    >['compareYourself'];
    hasCalculatedStats?: boolean;
  };
};

export default StatsSection;
